// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.IoGiftOutline = function IoGiftOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeMiterlimit": "10",
        "strokeWidth": "32",
        "d": "M256 104v56h56a56 56 0 10-56-56zm0 0v56h-56a56 56 0 1156-56z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "width": "384",
        "height": "112",
        "x": "64",
        "y": "160",
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "rx": "32",
        "ry": "32"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M416 272v144a48 48 0 01-48 48H144a48 48 0 01-48-48V272m160-112v304"
      }
    }]
  })(props);
};